import { webApi } from '@/shared/api/WebApi';
import type { IListRes } from '@lib2/model/common/ListRes';
import type { IsAvailResponse } from '@lib2/model/common/net/CommonApiResponseTypes';
import type {
  AppCfgFilesDto,
  AppCfgCreateReq,
  AppCfgUpdateReq,
  AppCfgWebCreateReq,
  AppCfgWebUpdateReq,
} from '@/lib/types/App';

export class AppApi {
  static async getApps(cId: number): Promise<IListRes<AppCfgFilesDto>> {
    return webApi.get<IListRes<AppCfgFilesDto>>('app', { cId });
  }

  static async getApp(cId: number, appCfgId: number): Promise<AppCfgFilesDto> {
    return webApi.get<AppCfgFilesDto>(`app/${appCfgId}`, { cId });
  }

  static async createApp(cId: number, req: AppCfgCreateReq): Promise<AppCfgFilesDto> {
    return webApi.post<AppCfgFilesDto>('app', { cId }, req);
  }

  static async updateApp(
    cId: number,
    appCfgId: number,
    req: AppCfgUpdateReq,
  ): Promise<AppCfgFilesDto> {
    return webApi.post<AppCfgFilesDto>(`app/${appCfgId}`, { cId }, req);
  }

  static async deleteApp(cId: number, appCfgId: number): Promise<void> {
    return webApi.delete<void>(`app/${appCfgId}`, { cId });
  }

  static async createAppWeb(cId: number, req: AppCfgWebCreateReq): Promise<AppCfgFilesDto> {
    return webApi.post<AppCfgFilesDto>('app/web', { cId }, req);
  }

  static async updateAppWeb(
    cId: number,
    appCfgId: number,
    req: AppCfgWebUpdateReq,
  ): Promise<AppCfgFilesDto> {
    return webApi.post<AppCfgFilesDto>(`app/web/${appCfgId}`, { cId }, req);
  }

  static async checkCustomNameAvailability(
    cId: number,
    customName: string,
  ): Promise<IsAvailResponse> {
    return webApi.get<IsAvailResponse>('app/web/check-custom-name', { cId, customName });
  }
}
